import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';


import {DatetimeModule} from '../../components/datetime/datetime.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import { AccountPermissionsService } from '../../services/account-permissions.service';
import { FrontDeskInstructionsService } from 'app/services/front-desk-instructions.service';
import { FrontDeskInstructionsComponent } from './front-desk-instructions.component';
import { FrontDeskInstructionsListComponent } from './front-desk-instructions-list/front-desk-instructions-list.component';
import { AddInstructionsModalModule } from 'app/components/directory/add-instructions-modal/add-instructions-modal.module';
import {UtilsModule} from '../../modules/utils/utils.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        AngularMaterialImportModule,
        AddInstructionsModalModule,
        UtilsModule
    ],
    declarations: [
        FrontDeskInstructionsComponent,
        FrontDeskInstructionsListComponent,
    ],
    providers: [
        FrontDeskInstructionsService,
        AccountPermissionsService
    ]
})
export class FrontDeskInstructionsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/front-desk-instructions/front-desk-instructions.module.ts